import { Component, OnInit } from '@angular/core';

import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

import { NewsService } from '../../services/newsService';

import { uploadService } from '../../services/uploadService'
import { Upload } from '../../entities/upload'

@Component({
  selector: 'app-edit-advertise',
  templateUrl: './edit-advertise.component.html',
  styleUrls: ['./edit-advertise.component.css']
})
export class EditAdvertiseComponent implements OnInit {

  idd;
  tempData;
  url;

  headerSlide;
  contentHeaderSlide;
  contentSlide;

  selectedFilesAdver: FileList;
  currentUpload: Upload;
  constructor(private _location: Location, private nsv: NewsService, private route: ActivatedRoute,private uS:uploadService) {

  }

  ngOnInit() {
    this.idd = this.route.snapshot.params['id'];
    this.tempData = this.nsv.getadverId(this.idd);

    if (this.tempData != null) {
      sessionStorage.setItem("is_reloaded_advertise", JSON.stringify(this.tempData))
    }else{
      this.tempData = JSON.parse(sessionStorage.getItem("is_reloaded_advertise"))
    }

    this.headerSlide = this.tempData.header;
    this.contentHeaderSlide = this.tempData.contentHeader;
    this.contentSlide = this.tempData.content;

    
  }
  backClicked() {
    this._location.back();
  }
  detectAdvertisement(event) {
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.url = event.target.result;
    }
    reader.readAsDataURL(event.target.files[0]);
    this.selectedFilesAdver = event.target.files;
  }
  EditData() {
    if (this.selectedFilesAdver) {
      let file = this.selectedFilesAdver.item(0)
      this.currentUpload = new Upload(file);

      let dataUpdate = {
        header: this.headerSlide,
        contentHeader: this.contentHeaderSlide,
        content: this.contentSlide
      }
      console.log(this.selectedFilesAdver.item(0))
      this.uS.UpdateAdvertise(dataUpdate,this.currentUpload,this.idd)
    }else{
      let dataUpdate = {
        header: this.headerSlide,
        contentHeader: this.contentHeaderSlide,
        content: this.contentSlide
      }
      this.nsv.updateAdvertise(dataUpdate, this.idd)
    }
  }
}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/edit-advertise/edit-advertise.component.ts